import Page from "@/pages/Page";
import Chat from "@/components/organisms/chat/index";

import { companyNameState, companyState, messagesState } from "@/client/state";
import { useRecoilState, useRecoilValue, useSetRecoilState } from "recoil";
import { GenAiContext } from "@/client/context";
import { accessTokenState } from "@/client/state";
import { useContext, useEffect } from "react";

export default function Home() {
  const [companyId, setCompanyId] = useRecoilState(companyState);
  const companyName = useRecoilValue(companyNameState);

  const apiClient = useContext(GenAiContext);
  const accessToken = useRecoilValue(accessTokenState);

  const setMessages = useSetRecoilState(messagesState);

  useEffect(() => {
    if (companyId && companyName) {
      const fetchCompanyMessage = async () => {
        try {
          const res = await apiClient.getAccountReport(companyId, accessToken);

          const now = new Date().toISOString();
          const step = {
            id: "0",
            name: "QNB AI",
            role: "assistant" as const,
            // content: res.data, TEMP
            content: `Ini merupakan data hasil generate report dari ${res.data.company_name}. 

[[file:${res.data.file_name}]]
            
Laporan ini disusun secara sistematis dengan tujuan memberikan gambaran menyeluruh mengenai kondisi perusahaan, menghadirkan insight yang relevan, serta mendukung proses analisis dan pengambilan keputusan strategis.

Apabila terdapat bagian yang perlu ditinjau lebih lanjut, memerlukan penjelasan tambahan, atau jika ada pertanyaan terkait informasi yang tercantum di dalam laporan, jangan ragu untuk menyampaikannya. Kami dengan senang hati siap memberikan klarifikasi maupun pendampingan sesuai kebutuhan Anda.`,
            timestamp: now,
          };

          setMessages([step]);
        } catch (error) {
          console.error("Failed to fetch company message:", error);
        }
      };

      fetchCompanyMessage();
    }
  }, [companyId, companyName]); // 🔹 Depend on both for dynamic updates

  return (
    <Page companyId={companyId} setCompanyId={setCompanyId}>
      <Chat companyId={companyId} />
    </Page>
  );
}
